import { useQueryClient } from '@tanstack/react-query'

import { getNacionalidadePrincipalId } from '@/features/proposta/shared/domain/nacionalidade'
import type { TNacionalidade } from '@/types/cliente'
import { nacionalidadeClienteKeys } from '@/utils/cliente-query-keys'

export const useNacionalidadeCache = () => {
  const queryClient = useQueryClient()

  const nacionalidades = queryClient.getQueryData<TNacionalidade[]>(nacionalidadeClienteKeys.lista()) ?? []

  return {
    nacionalidades,
    nacionalidadePrincipalId: getNacionalidadePrincipalId(nacionalidades),
  }
}
